/** @file The environment variable that holds a token in client configs: POSE2D_TOKEN_<NAME>. */

/** The bootstrap token names keep their fixed variables (exact names only). */
const ALIASES: Readonly<Record<string, string>> = { 'claude-code': 'POSE2D_TOKEN_CLAUDE', codex: 'POSE2D_TOKEN_CODEX', cli: 'POSE2D_TOKEN_CLI' };

/** `claude-code` → `POSE2D_TOKEN_CLAUDE` (alias); `claude-code-2` → `POSE2D_TOKEN_CLAUDE_CODE_2`: upper case, runs of other characters one `_`. */
export function tokenEnvName(tokenName: string): string {
  const alias = Object.hasOwn(ALIASES, tokenName) ? ALIASES[tokenName] : undefined;
  if (alias !== undefined) return alias;
  const stem = tokenName.toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  return stem === '' ? 'POSE2D_TOKEN' : `POSE2D_TOKEN_${stem}`;
}
